export default __webpack_public_path__ + "static/media/NotAllowedGroup.ff17dfb6.svg";